// extracted by mini-css-extract-plugin
module.exports = {"studentyearnav":"Animated_studentyearnav__ryLkN","review":"Animated_review__3e-R7","articlefeedback":"Animated_articlefeedback__3AnlT"};